import type { TranslationModule } from '../types';

export const dosareUrmariteTranslations: TranslationModule = {
  ro: {
    seo: {
      title: "Dosare Urmărite & Modificări Legislative | Monitorizare Instanțe & Alerte Legi | Legea Aplicată",
      description: "Urmărește automat dosarele de instanță din România și modificările din legislație. Primește alerte pe email la fiecare termen nou din instanțe și la publicarea legilor în Monitorul Oficial.",
      keywords: "dosare urmarite, modificari legislative, alerte legi, monitorizare dosare instanta, alerte email dosare, urmarire dosare judecata, legea aplicata",
      ogTitle: "Dosare Urmărite & Alerte Legislative — Legea Aplicată",
      ogDescription: "Notificări automate pentru termene de judecată din instanțe și modificări legislative publicate în Monitorul Oficial.",
      ogImageAlt: "Legea Aplicată — Monitorizare Dosare Urmărite & Alerte Legislative",
    },
    breadcrumb: {
      home: "Acasă",
      guide: "Ghidul celor 44 de Funcții",
      followedCases: "Dosare de Instanță Urmărite",
      legislativeChanges: "Modificări Legislative de Interes",
    },
    header: {
      titleCases: "Dosare Urmărite & Alerte",
      subtitleCases: "Lista tuturor dosarelor de judecată pentru care primești notificări automate la fiecare actualizare în portal.",
      titleLegislative: "Modificări Legislative de Interes",
      subtitleLegislative: "Monitorizare continuă a modificărilor apărute în actele normative din domeniile tale de interes.",
      viewDailyChanges: "Vezi Modificări Legislative la Zi (40 Acte)",
    },
    tabs: {
      cases: "📁 Dosare de Instanță Urmărite",
      legislative: "⚖️ Modificări Legislative de Interes",
    },
    quickLookup: {
      title: "Adaugă rapid un dosar nou la monitorizare",
      description: "Caută dosarul după numărul de înregistrare (ex: 36895/302/2026/a1) sau după nume parte / firmă în ECRIS și activează butonul „Urmărește dosarul” (funcție Pro) pentru notificări pe email.",
      placeholder: "Nr. dosar (ex: 36895/302/2026/a1) sau nume parte / firmă...",
      ariaLabel: "Număr dosar sau nume parte ori firmă de adăugat la urmărire",
      submitButton: "Caută & Urmărește",
    },
    guestCta: {
      proBadge: "Funcție Pro",
      title: "Monitorizarea automată și alertele sunt disponibile în Pro",
      subtitle: "Poți consulta dosarele și informațiile legislative publice. Pentru monitorizare automată și notificări este necesar acces Pro.",
      howItWorksTitle: "Cum funcționează urmărirea dosarelor?",
      steps: [
        {
          step: "1",
          title: "Cauți dosarul",
          desc: "Introduci numărul unic sau cauți după denumirea unei părți în portalul național."
        },
        {
          step: "2",
          title: "Salvezi dosarul",
          desc: "Dai click pe butonul de urmărire din pagina detalii dosar pentru a-l adăuga în cont."
        },
        {
          step: "3",
          title: "Notificări instant",
          desc: "Primești alertă imediat prin email la orice modificare de termen, ședință sau soluție."
        }
      ],
      monitoredInfoTitle: "Informații publice monitorizate permanent din portal.just.ro:",
      monitoredInfoList: [
        "Data înregistrării și ultima actualizare a dosarului",
        "Instanța, secția competentă și completul de judecată",
        "Categoria dosarului și stadiul procesual (Fond, Apel etc.)",
        "Lista completă a părților implicate (Reclamant, Pârât etc.)",
        "Termenele stabilite și ședințele programate",
        "Căile de atac declarate și soluțiile pronunțate"
      ],
      viewProPlans: "Vezi abonamentele Pro",
      login: "Autentificare",
    },
    basicPaywall: {
      proBadge: "Funcție Pro",
      title: "Dosare Urmărite & Alerte este o funcție Pro",
      subtitle: "Monitorizarea automată a modificărilor din dosare este disponibilă utilizatorilor Pro. Treci la Pro pentru a primi notificări în cont și pe email atunci când apar actualizări relevante.",
      includedTitle: "Ce include monitorizarea dosarelor în Pro:",
      includedList: [
        "Notificări automate la stabilirea unor noi termene de judecată",
        "Alerte la soluțiile pronunțate și dispozitivul hotărârilor",
        "Actualizări la declararea căilor de atac (apel, recurs)",
        "Urmărirea stadiului procesual și schimbărilor de complet",
        "Rapoarte zilnice pe email cu modificările detectate",
        "Păstrarea dosarelor urmărite fără a fi necesară verificarea zilnică manuală"
      ],
      viewProPlans: "Vezi abonamentele Pro",
      searchCase: "Caută dosar în instanță",
    },
    proView: {
      title: "Dosare Urmărite",
      subtitle: "Lista tuturor dosarelor de judecată pentru care primești notificări automate la fiecare actualizare în portal.",
      searchNewCase: "Caută dosar nou",
      loading: "Se încarcă dosarele urmărite...",
      errorTitle: "A apărut o eroare",
      errorDefault: "Nu s-au putut încărca dosarele urmărite. Vă rugăm reîncercați.",
      retry: "Reîncearcă",
      emptyTitle: "Nu urmăriți niciun dosar momentan",
      emptyDescription: "Căutați dosare în instanță folosind caseta de căutare de mai sus și apăsați pe butonul de urmărire din fișa de detalii pentru a primi alerte pe email la orice modificare de termen sau soluție.",
      startSearch: "Începe căutarea dosarelor",
      noSubject: "Fără obiect specificat",
      court: "Instanță:",
      proceduralStage: "Stadiu procesual:",
      registrationDate: "Dată înregistrare:",
      addedAt: "Adăugat la:",
      lastHearing: "Ultimul termen:",
      noHearingScheduled: "Niciun termen programat",
      pastHearing: "Termen anterior",
      unfollowTitle: "Oprește urmărirea",
      confirmUnfollow: "Sigur doriți să opriți urmărirea dosarului nr. {number}?",
      unfollowError: "Eroare la dezactivarea urmăririi.",
    },
    faq: {
      title: "Întrebări frecvente — Monitorizare & Alerte",
      items: [
        {
          q: "Cum adaug un dosar în lista de Dosare Urmărite?",
          a: "Cu un abonament Pro activ, cauți dosarul după numărul unic de înregistrare (inclusiv extensii /a1) sau după numele părții ori firmei direct în bara de căutare rapidă de mai sus sau în pagina Căutare Dosar Instanță, apoi apeși pe butonul „Urmărește dosarul”."
        },
        {
          q: "Când primesc notificări pe email pentru dosarele urmărite?",
          a: "Pentru utilizatorii Pro, sistemul verifică periodic portalul instanțelor și trimite automat o alertă pe email ori de câte ori apare un termen nou de judecată, o modificare de stadiu procesual, o cale de atac declarată sau o soluție pe scurt."
        },
        {
          q: "Cum funcționează alertele pentru Modificări Legislative?",
          a: "Cu acces Pro, în tab-ul „Modificări Legislative de Interes” selectezi domeniile juridice relevante (Penal, Civil, Fiscal, Administrativ, Muncă, Comercial) și bifezi acordul de primire pe email. Sistemul îți trimite automat noutățile apărute în Monitorul Oficial din momentul abonării."
        },
        {
          q: "Pot opri oricând monitorizarea unui dosar sau a alertelor legislative?",
          a: "Da. Pentru dosare poți apăsa pe pictograma de ștergere a oricărui dosar urmărit, iar pentru legislație poți dezactiva oricând switch-ul de email din panoul de preferințe, chiar și dacă abonamentul a revenit la Basic."
        }
      ]
    },
    relatedTools: {
      title: "Unelte conexe pentru juriști și avocați",
      searchByNumber: "Căutare Dosar după Număr Unic",
      proceduralDeadlines: "Calculator Termene Procedurale",
      crmStorage: "CRM Juridic & Stocare Privată",
    },
    disclaimer: "Datele despre dosare provin exclusiv din portalul public al instanțelor de judecată. Informațiile sunt preluate din surse publice și au caracter informativ. LegeaAplicata.ro nu oferă consultanță juridică și nu se substituie comunicărilor oficiale ale instanței. Pentru actele de procedură, verifică întotdeauna sursele oficiale.",
  },
  en: {
    seo: {
      title: "Followed Court Cases & Legislative Alerts | Court Monitoring & Law Updates | Legea Aplicată",
      description: "Automatically track court cases in Romania and legislative amendments from the Official Gazette. Receive email alerts and notifications for hearings, rulings, and law updates.",
      keywords: "followed court cases, legislative alerts, court case monitoring, email legal alerts, romanian courts ecris, official gazette, legea aplicata",
      ogTitle: "Followed Court Cases & Legislative Alerts — Legea Aplicată",
      ogDescription: "Automated notifications for court hearings, rulings, and legislative amendments published in the Official Gazette.",
      ogImageAlt: "Legea Aplicată — Court Cases Monitoring & Legislative Alerts",
    },
    breadcrumb: {
      home: "Home",
      guide: "Guide to 44 Features",
      followedCases: "Followed Court Cases",
      legislativeChanges: "Legislative Changes of Interest",
    },
    header: {
      titleCases: "Followed Cases & Alerts",
      subtitleCases: "List of all court cases for which you receive automatic notifications whenever updates appear in the national court portal.",
      titleLegislative: "Legislative Changes of Interest",
      subtitleLegislative: "Continuous monitoring of amendments in legal acts across your areas of practice.",
      viewDailyChanges: "View Daily Legislative Updates (40 Acts)",
    },
    tabs: {
      cases: "📁 Followed Court Cases",
      legislative: "⚖️ Legislative Changes of Interest",
    },
    quickLookup: {
      title: "Quickly add a new case to monitoring",
      description: "Search for the case by its unique number (e.g. 36895/302/2026/a1) or by party/company name in ECRIS and click 'Follow case' (Pro feature) for email alerts.",
      placeholder: "Case number (e.g. 36895/302/2026/a1) or party / company name...",
      ariaLabel: "Case number or party/company name to add to monitoring",
      submitButton: "Search & Follow",
    },
    guestCta: {
      proBadge: "Pro Feature",
      title: "Automated monitoring and alerts are available in Pro",
      subtitle: "You can consult public court cases and legislation freely. Automated monitoring and email notifications require Pro access.",
      howItWorksTitle: "How does court case monitoring work?",
      steps: [
        {
          step: "1",
          title: "Find the case",
          desc: "Enter the unique case number or search by party name in the national court portal."
        },
        {
          step: "2",
          title: "Save the case",
          desc: "Click the follow button on the case details sheet to add it to your account."
        },
        {
          step: "3",
          title: "Instant alerts",
          desc: "Receive instant email alerts whenever hearings, sessions, or rulings are updated."
        }
      ],
      monitoredInfoTitle: "Public information monitored continuously from portal.just.ro:",
      monitoredInfoList: [
        "Registration date and last update timestamp",
        "Competent court, judicial chamber, and judging panel",
        "Case category and procedural stage (First instance, Appeal, etc.)",
        "Complete list of parties involved (Claimant, Defendant, etc.)",
        "Scheduled hearings and court sessions",
        "Declared appeals and pronounced judgments"
      ],
      viewProPlans: "View Pro plans",
      login: "Log in",
    },
    basicPaywall: {
      proBadge: "Pro Feature",
      title: "Followed Cases & Alerts is a Pro feature",
      subtitle: "Automated monitoring of case updates is available to Pro users. Upgrade to Pro to receive account and email notifications whenever relevant updates occur.",
      includedTitle: "What Pro case monitoring includes:",
      includedList: [
        "Automated alerts when new court hearings are scheduled",
        "Notifications for pronounced rulings and operative provisions",
        "Updates upon filing of appeals (ordinary or extraordinary)",
        "Tracking of procedural stage and court panel changes",
        "Daily email summary reports with detected modifications",
        "Persistent tracking without needing to manually inspect portals daily"
      ],
      viewProPlans: "View Pro plans",
      searchCase: "Search court case",
    },
    proView: {
      title: "Followed Cases",
      subtitle: "List of all court cases for which you receive automated notifications on each portal update.",
      searchNewCase: "Search new case",
      loading: "Loading followed cases...",
      errorTitle: "An error occurred",
      errorDefault: "Could not load followed cases. Please try again.",
      retry: "Retry",
      emptyTitle: "You are not following any cases yet",
      emptyDescription: "Search for court cases using the search bar above and click the follow button on the details page to receive email alerts on any hearing or decision change.",
      startSearch: "Start searching cases",
      noSubject: "No subject specified",
      court: "Court:",
      proceduralStage: "Procedural stage:",
      registrationDate: "Registration date:",
      addedAt: "Added on:",
      lastHearing: "Last hearing:",
      noHearingScheduled: "No hearing scheduled",
      pastHearing: "Past hearing",
      unfollowTitle: "Stop tracking",
      confirmUnfollow: "Are you sure you want to stop tracking case no. {number}?",
      unfollowError: "Error stopping case tracking.",
    },
    faq: {
      title: "Frequently Asked Questions — Monitoring & Alerts",
      items: [
        {
          q: "How do I add a case to Followed Cases?",
          a: "With an active Pro subscription, search for the case by its unique docket number (including extensions such as /a1) or by party/company name in the quick search bar or the Court Case Search page, then click 'Follow case'."
        },
        {
          q: "When do I receive email alerts for followed cases?",
          a: "For Pro users, the system periodically checks the national court portal and sends an email alert whenever a new hearing is scheduled, the procedural stage changes, an appeal is declared, or a decision is published."
        },
        {
          q: "How do legislative change alerts work?",
          a: "With Pro access, in the 'Legislative Changes of Interest' tab select relevant legal domains (Criminal, Civil, Fiscal, Administrative, Labor, Commercial) and enable email notifications. The system will automatically email you changes published in the Official Gazette."
        },
        {
          q: "Can I stop tracking a case or legislative alerts at any time?",
          a: "Yes. For cases you can click the delete icon on any tracked case, and for legislation you can disable email alerts anytime in the preferences panel, even if your plan has returned to Basic."
        }
      ]
    },
    relatedTools: {
      title: "Related tools for legal practitioners and attorneys",
      searchByNumber: "Search Case by Unique Number",
      proceduralDeadlines: "Procedural Deadlines Calculator",
      crmStorage: "Legal CRM & Private Storage",
    },
    disclaimer: "Case data comes exclusively from the public portal of the courts of law. The information is retrieved from public sources and is for informational purposes only. LegeaAplicata.ro does not provide legal advice and does not replace official court notices. For procedural acts, always verify official sources.",
  },
  fr: {
    seo: {
      title: "Dossiers Suivis & Alertes Législatives | Suivi des Tribunaux & Lois | Legea Aplicată",
      description: "Suivez automatiquement les dossiers judiciaires en Roumanie et les modifications législatives du Journal Officiel. Recevez des notifications par e-mail pour chaque audience ou décision.",
      keywords: "dossiers suivis, alertes legislatives, suivi tribunaux roumanie, alertes email dossiers, journal officiel roumanie, legea aplicata",
      ogTitle: "Dossiers Suivis & Alertes Législatives — Legea Aplicată",
      ogDescription: "Notifications automatisées pour les audiences judiciaires, les jugements et les modifications législatives publiées au Journal Officiel.",
      ogImageAlt: "Legea Aplicată — Suivi des Dossiers & Alertes Législatives",
    },
    breadcrumb: {
      home: "Accueil",
      guide: "Guide des 44 Fonctionnalités",
      followedCases: "Dossiers Judiciaires Suivis",
      legislativeChanges: "Modifications Législatives d'Intérêt",
    },
    header: {
      titleCases: "Dossiers Suivis & Alertes",
      subtitleCases: "Liste de tous les dossiers judiciaires pour lesquels vous recevez des notifications automatiques à chaque mise à jour sur le portail des tribunaux.",
      titleLegislative: "Modifications Législatives d'Intérêt",
      subtitleLegislative: "Surveillance continue des modifications des textes législatifs dans vos domaines de pratique.",
      viewDailyChanges: "Voir les Mises à Jour Législatives Quotidiennes (40 Actes)",
    },
    tabs: {
      cases: "📁 Dossiers Judiciaires Suivis",
      legislative: "⚖️ Modifications Législatives d'Intérêt",
    },
    quickLookup: {
      title: "Ajouter rapidement un nouveau dossier au suivi",
      description: "Recherchez le dossier par son numéro unique (ex: 36895/302/2026/a1) ou par le nom d'une partie/société dans ECRIS et cliquez sur « Suivre le dossier » (fonction Pro) pour recevoir des alertes par e-mail.",
      placeholder: "Numéro de dossier (ex: 36895/302/2026/a1) ou nom de partie / société...",
      ariaLabel: "Numéro de dossier ou nom de partie/société à ajouter au suivi",
      submitButton: "Rechercher & Suivre",
    },
    guestCta: {
      proBadge: "Fonction Pro",
      title: "Le suivi automatisé et les alertes sont disponibles dans Pro",
      subtitle: "Vous pouvez consulter librement les dossiers judiciaires publics et la législation. Le suivi automatisé et les notifications par e-mail nécessitent un accès Pro.",
      howItWorksTitle: "Comment fonctionne le suivi des dossiers ?",
      steps: [
        {
          step: "1",
          title: "Cherchez le dossier",
          desc: "Saisissez le numéro unique ou effectuez une recherche par nom de partie dans le portail national des tribunaux."
        },
        {
          step: "2",
          title: "Enregistrez le dossier",
          desc: "Cliquez sur le bouton de suivi dans la fiche détaillée du dossier pour l'ajouter à votre compte."
        },
        {
          step: "3",
          title: "Alertes instantanées",
          desc: "Recevez une alerte immédiate par e-mail à chaque modification d'audience, de session ou de jugement."
        }
      ],
      monitoredInfoTitle: "Informations publiques surveillées en permanence depuis portal.just.ro :",
      monitoredInfoList: [
        "Date d'enregistrement et dernière mise à jour du dossier",
        "Tribunal compétent, chambre et collège de juges",
        "Catégorie de dossier et phase de procédure (Fond, Appel, etc.)",
        "Liste complète des parties impliquées (Demandeur, Défendeur, etc.)",
        "Audiences fixées et séances programmées",
        "Voies de recours exercées et solutions prononcées"
      ],
      viewProPlans: "Voir les abonnements Pro",
      login: "Connexion",
    },
    basicPaywall: {
      proBadge: "Fonction Pro",
      title: "Dossiers Suivis & Alertes est une fonctionnalité Pro",
      subtitle: "Le suivi automatisé des mises à jour des dossiers est réservé aux abonnés Pro. Passez à Pro pour recevoir des alertes par e-mail et sur votre compte dès qu'une modification survient.",
      includedTitle: "Ce que comprend le suivi des dossiers dans Pro :",
      includedList: [
        "Notifications automatiques dès la fixation de nouvelles audiences",
        "Alertes pour les jugements prononcés et le dispositif des décisions",
        "Mises à jour lors de l'exercice des voies de recours (appel, pourvoi)",
        "Suivi du stade de la procédure et des changements de composition du tribunal",
        "Rapports quotidiens par e-mail récapitulant les modifications détectées",
        "Conservation permanente des dossiers suivis sans vérification manuelle quotidienne"
      ],
      viewProPlans: "Voir les abonnements Pro",
      searchCase: "Rechercher un dossier au tribunal",
    },
    proView: {
      title: "Dossiers Suivis",
      subtitle: "Liste de tous les dossiers judiciaires pour lesquels vous recevez des notifications automatiques à chaque mise à jour sur le portail.",
      searchNewCase: "Rechercher un nouveau dossier",
      loading: "Chargement des dossiers suivis...",
      errorTitle: "Une erreur est survenue",
      errorDefault: "Impossible de charger les dossiers suivis. Veuillez réessayer.",
      retry: "Réessayer",
      emptyTitle: "Vous ne suivez aucun dossier pour le moment",
      emptyDescription: "Recherchez des dossiers judiciaires à l'aide de la barre de recherche ci-dessus et cliquez sur le bouton de suivi pour recevoir des alertes par e-mail à chaque changement d'audience ou de décision.",
      startSearch: "Commencer la recherche de dossiers",
      noSubject: "Aucun objet spécifié",
      court: "Tribunal :",
      proceduralStage: "Phase de procédure :",
      registrationDate: "Date d'enregistrement :",
      addedAt: "Ajouté le :",
      lastHearing: "Dernière audience :",
      noHearingScheduled: "Aucune audience programmée",
      pastHearing: "Audience passée",
      unfollowTitle: "Arrêter le suivi",
      confirmUnfollow: "Êtes-vous sûr de vouloir arrêter le suivi du dossier n° {number} ?",
      unfollowError: "Erreur lors de la désactivation du suivi.",
    },
    faq: {
      title: "Foire aux questions — Suivi & Alertes",
      items: [
        {
          q: "Comment ajouter un dossier à la liste des Dossiers Suivis ?",
          a: "Avec un abonnement Pro actif, recherchez le dossier par son numéro unique (y compris les extensions /a1) ou par le nom d'une partie/société dans la barre de recherche rapide ci-dessus ou sur la page Recherche de Dossier, puis cliquez sur « Suivre le dossier »."
        },
        {
          q: "Quand est-ce que je reçois des notifications par e-mail pour les dossiers suivis ?",
          a: "Pour les utilisateurs Pro, le système consulte périodiquement le portail des tribunaux et envoie une alerte automatique par e-mail dès qu'une nouvelle audience est fixée, que le stade de la procédure change, qu'un recours est exercé ou qu'un jugement est prononcé."
        },
        {
          q: "Comment fonctionnent les alertes de modifications législatives ?",
          a: "Avec l'accès Pro, dans l'onglet « Modifications Législatives d'Intérêt », sélectionnez les matières juridiques souhaitées (Pénal, Civil, Fiscal, Administratif, Travail, Commercial) et activez la réception par e-mail. Le système vous envoie automatiquement les textes parus au Journal Officiel."
        },
        {
          q: "Puis-je arrêter à tout moment le suivi d'un dossier ou des alertes législatives ?",
          a: "Oui. Pour les dossiers, vous pouvez cliquer sur l'icône de suppression de tout dossier suivi, et pour la législation, désactiver l'interrupteur d'e-mail dans le panneau des préférences, même si votre abonnement est redevenu Basic."
        }
      ]
    },
    relatedTools: {
      title: "Outils connexes pour juristes et avocats",
      searchByNumber: "Recherche de Dossier par Numéro Unique",
      proceduralDeadlines: "Calculateur de Délais de Procédure",
      crmStorage: "CRM Juridique & Stockage Privé",
    },
    disclaimer: "Les données relatives aux dossiers proviennent exclusivement du portail public des cours et tribunaux. Les informations sont issues de sources publiques et ont un caractère purement informatif. LegeaAplicata.ro ne fournit pas de conseils juridiques et ne remplace pas les notifications officielles du tribunal. Pour les actes de procédure, vérifiez toujours les sources officielles.",
  }
};
